import { NavLogo } from './NavbarElements2'
import { HashLink } from 'react-router-hash-link';
import { CgFormatRight } from "react-icons/cg";
import './Navbar2.css'

const index = ({ toggle }) => {
  return (
    <div className='Nav2'>
        <div className='NavbarContainer'>
            <NavLogo to='/'>
                <div className='Navlogo2' />
            </NavLogo>
             <div className='MobileIcon2' onClick={toggle}>
                    <CgFormatRight />
            </div>
            
            <ul className='nav-links2'>
                <li>
                    <NavLogo to='/menu'>
                        Menu
                    </NavLogo>
                </li>
                <li>
                    <HashLink to='/#about' smooth={true} duration={2500}>
                        About us
                    </HashLink>
                </li>                
                <li>
                    <HashLink to='/#contact' smooth={true} duration={2000}  className='NavLinks'>
                        Contact us
                    </HashLink>
                </li>
                <li>
                    <a href='https://billetto.se/e/vocco-night-access-biljetter-2027863?utm_source=organiser&utm_medium=share&utm_campaign=copy_link&utm_content=2' className='NavLinks'>
                        Buy tickets
                    </a>
                </li>  
                <li>
                    <HashLink to='/#booking'>
                        Book table
                    </HashLink>
                </li>   
            </ul>
        </div>
    </div>
  )
}

export default index